/**
 * Decal property formatter: formats decal properties for the details panel.
 */
import { formatColorRgba } from '../../../utils/colorParser';
import { formatNode3DProperties } from '../../base/node3d/propertyFormatter';
export function formatDecalProperties(properties) {
    const sections = [];
    const textureItems = [
        { label: 'Albedo', value: properties.texture_albedo ?? '(none)' },
    ];
    if (properties.texture_normal) {
        textureItems.push({ label: 'Normal', value: properties.texture_normal });
    }
    if (properties.texture_orm) {
        textureItems.push({ label: 'ORM', value: properties.texture_orm });
    }
    if (properties.texture_emission) {
        textureItems.push({ label: 'Emission', value: properties.texture_emission });
    }
    sections.push({ title: 'Textures', items: textureItems });
    sections.push({
        title: 'Projection',
        items: [
            {
                label: 'Size',
                value: `(${properties.size.x}, ${properties.size.y}, ${properties.size.z})`,
            },
            { label: 'Modulate', value: formatColorRgba(properties.modulate) },
            { label: 'Albedo Mix', value: properties.albedo_mix.toFixed(2) },
            { label: 'Normal Fade', value: properties.normal_fade.toFixed(2) },
            { label: 'Upper Fade', value: properties.upper_fade.toFixed(2) },
            { label: 'Lower Fade', value: properties.lower_fade.toFixed(2) },
            { label: 'Cull Mask', value: `0x${properties.cull_mask.toString(16)}` },
        ],
    });
    sections.push({
        title: 'Distance Fade',
        items: [
            { label: 'Enabled', value: properties.distance_fade_enabled ? 'true' : 'false' },
            { label: 'Begin', value: properties.distance_fade_begin.toFixed(2) },
            { label: 'Length', value: properties.distance_fade_length.toFixed(2) },
        ],
    });
    sections.push(...formatNode3DProperties(properties));
    return sections;
}
//# sourceMappingURL=propertyFormatter.js.map